<div mat-dialog-title
     class="title">
    <div class="subtitle">{{ formTitle | translate }}</div>
    <button mat-icon-button
            mat-dialog-close
            tabindex="-1"
            [matTooltip]="'Close' | translate"
            class="close-button hidden">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div class="line line-margin">
        <mat-form-field color="primary">
            <input matInput
                    #lastnameInput
                    [required]="true"
                    [formControl]="lastnameFormControl"
                    type="text"
                    maxlength="{{ NAME_MAX_LENGTH }}"
                    [placeholder]="'Lastname' | translate">
            <mat-error *ngIf="lastnameFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field color="primary">
            <input matInput
                    #firstnameInput
                    [required]="true"
                    [formControl]="firstnameFormControl"
                    type="text"
                    maxlength="{{ NAME_MAX_LENGTH }}"
                    [placeholder]="'Firstname' | translate">
            <mat-error *ngIf="firstnameFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
        </mat-form-field>
    </div>
    <div class="line line-margin">
        <mat-form-field color="primary">
            <input matInput
                    #emailInput
                    [required]="true"
                    [formControl]="emailFormControl"
                    type="email"
                    maxlength="{{ NAME_MAX_LENGTH }}"
                    [placeholder]="'Email_Address' | translate"
                    (keyup)="onEmailChanged()">
            <mat-error *ngIf="emailFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
            <mat-error *ngIf="emailFormControl.hasError('unavailable')">{{ 'Email_unavailable' | translate }}</mat-error>
        </mat-form-field>
    </div>
    <div class="line line-margin">
        <mat-form-field color="primary">
            <input matInput
                    #phoneNumberInput
                    [formControl]="phoneNumberFormControl"
                    type="text"
                    maxlength="{{ NAME_MAX_LENGTH }}"
                    [placeholder]="'Phone_Number' | translate">
        </mat-form-field>
    </div>
    <div class="line line-margin">
        <mat-checkbox color="primary"
                      [disabled]="!rights.CHANGE_SUPERCOACH_FLAG"
                      [(ngModel)]="isSuperCoach">
            {{ 'Super_coach_role' | translate }}
        </mat-checkbox>
    </div>
    <div class="line">
        <input-image color="primary"
                     [placeholder]="'Profile_picture'"
                     [allowedExtensions]="usersProvider.AVATAR_ALLOWED_EXTENSIONS"
                     [imageHost]="conf.storageRootUrl"
                     [maxFileSize]="usersProvider.AVATAR_MAX_SIZE"
                     [hint]="'Image_file_hint' | translate:{width: usersProvider.AVATAR_MAX_WIDTH, height: usersProvider.AVATAR_MAX_HEIGHT, size: usersProvider.AVATAR_MAX_SIZE}"
                     [(ngModel)]="avatarImage"></input-image>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button
            mat-dialog-close
            tabindex="-1">
        {{ 'Cancel' | translate}}
    </button>
    <button mat-raised-button
            (click)="onSaveClicked()"
            color="accent">
        {{ 'Save' | translate}}
    </button>
</mat-dialog-actions>
<div class="progress-container">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>
